/**
 * Config web de Firebase para las push de la PWA — un proyecto de Firebase POR AMBIENTE, igual
 * que el backend: cada BE manda con las credenciales del proyecto donde corre, así que el FE tiene
 * que registrar el token contra ESE mismo proyecto (un token de un proyecto no sirve en el otro).
 *
 *  - Producción → proyecto `production-471920`.
 *  - Todo lo demás (staging, localhost) → proyecto `staging-471920`.
 *
 * NO son secretos: la config del SDK web y la clave VAPID pública se sirven al navegador de todos
 * modos, por eso van en el repo y no como env vars (una env var nueva del FE frenaría el merge
 * hasta que alguien la cargue en GitLab). El ambiente se decide por el dominio de la página, no por
 * una variable de build, así un mismo bundle nunca queda apuntando al proyecto equivocado.
 *
 * Dónde sacarlas — Firebase console → proyecto → Configuración → General → "Tus apps" → app web
 * (config del SDK) y Cloud Messaging → "Certificados push web" (clave VAPID).
 */
export interface FirebaseSettings {
  config: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
  vapidKey: string;
}

const STAGING: FirebaseSettings = {
  config: {
    apiKey: 'AIzaSyDDEWAOx7GLTDnT97vnT-meLKbgthzZZmo',
    authDomain: 'staging-471920.firebaseapp.com',
    projectId: 'staging-471920',
    storageBucket: 'staging-471920.firebasestorage.app',
    messagingSenderId: '844889227852',
    appId: '1:844889227852:web:5a2aca8e7240304ba6aae9',
  },
  vapidKey: 'BETfSx3sVqVc2NP7hOoF-FH96G-r8tN24O1-xLVJAekThxEyQkNtwSXTrk7ojxyi5KRdwGpQN_mGw8Uw6avp55U',
};

const PRODUCTION: FirebaseSettings = {
  config: {
    apiKey: 'AIzaSyAlnD88qELlwqAvkfCfv01qajZ-WWy5_hY',
    authDomain: 'production-471920.firebaseapp.com',
    projectId: 'production-471920',
    storageBucket: 'production-471920.firebasestorage.app',
    messagingSenderId: '996565287944',
    appId: '1:996565287944:web:e9796cc98abcf0dcfb7dbd',
  },
  vapidKey: 'BLYrJ5hF2mEoVB_ANr03_19ymW6-83by5yTTEnrX1UrYQyNh4EN9-m255p2KnM3HbD_RPzJ2JtNcGBlHwxPtcM4',
};

/** Dominios del hosting de producción (el custom domain y los del sitio `psi-platform`). */
const PRODUCTION_HOSTNAMES = new Set([
  'psiplatform.psimammoliti.com',
  'psi-platform.web.app',
  'psi-platform.firebaseapp.com',
]);

export function resolveFirebaseSettings(hostname: string): FirebaseSettings {
  return PRODUCTION_HOSTNAMES.has(hostname) ? PRODUCTION : STAGING;
}

export function getFirebaseSettings(): FirebaseSettings {
  return resolveFirebaseSettings(window.location.hostname);
}

export function isPushConfigured(): boolean {
  const { config, vapidKey } = getFirebaseSettings();
  return Boolean(config.apiKey && config.messagingSenderId && config.appId && vapidKey);
}
